module.exports = __webpack_public_path__ + "img/1 (59).ba957702.png";